import React from "react";
import { Button, Icon, Text } from '@rebrandly/styleguide'
import {func, string} from "prop-types";
const SuccessBox = ({title, buttonLabel, onButtonClick}) => {
    return (
        <div className='ShortenedLink__box-container'>
            <div className='ShortenedLink__blue-box ShortenedLink__blue-box-center'>
                <Icon name='ic-click' color='var(--color-black)'
                />
            </div>
            <div className='ShortenedLink__box-content'>
                <div className='ShortenedLink__box-text ShortenedLink__text_wrapper'>
                    <Text className='font-bold'>{title}</Text>
                    <Text size='small'>Get started for free and unlock your link management journey!</Text>
                </div>
                <Button theme='primary' size='lg' onClick={onButtonClick}><span className='font-bold'>{buttonLabel}</span></Button>
            </div>
        </div>
    )
}
SuccessBox.propTypes = {
    title: string,
    buttonLabel: string,
    onButtonClick: func,
}
export default SuccessBox